import { useState } from 'react';
import Card from '../../../components/base/Card';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Quando escolher Barcode<span className="trademark">®</span> ou Barcode<span className="trademark">®</span> Pro?',
      answer: 'Barcode<span className="trademark">®</span> é ideal para triagem de rotina e controle de contaminantes, oferecendo identificação até gênero com alta velocidade. Barcode<span className="trademark">®</span> Pro é recomendado para auditorias e certificações, garantindo identificação até espécie através de análise MLST.'
    },
    {
      question: 'Quais são os entregáveis do Barcode<span className="trademark">®</span> Meta?',
      answer: 'O Barcode<span className="trademark">®</span> Meta fornece relatório interativo completo no sistema Lumus<span className="trademark">®</span>, incluindo identificação de comunidades microbianas, métricas de diversidade, abundância relativa e análise de organismos não cultiváveis.'
    },
    {
      question: 'Quais são os prazos de cada serviço?',
      answer: 'Barcode<span className="trademark">®</span>: 3-5 dias úteis para resultados padrão. Barcode<span className="trademark">®</span> Pro: 7-10 dias úteis devido à análise multilocus. Barcode<span className="trademark">®</span> Meta: 10-15 dias úteis considerando o processamento NGS e análise bioinformática complexa.'
    },
    {
      question: 'Em que formatos os resultados são entregues?',
      answer: 'Todos os resultados são disponibilizados através do sistema Lumus<span className="trademark">®</span> em formato digital, com laudos técnicos em PDF, dados brutos em formatos padrão da indústria e relatórios interativos para análises avançadas.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-crop-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-xl font-gilroy text-crop-dark">
            Esclarecimentos sobre nossos serviços de identificação molecular
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Card key={index} className="animate-fade-in">
              <button
                className="w-full text-left flex justify-between items-center focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="font-gilroy font-semibold text-crop-black text-lg pr-4" dangerouslySetInnerHTML={{ __html: faq.question }}>
                </h3>
                <div className="flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-crop-black transition-transform duration-300`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="mt-4 pt-4 border-t border-crop-teal/20 animate-fade-in">
                  <p className="font-gilroy text-crop-dark leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }}>
                  </p>
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
